import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Agent, AgentCmmunicationTypeEnum, AgentTypeEnum } from '@trendbuild/trend-gpt-maker-api';
import { AbstractComponent, Channel, ChannelService } from 'lib-trend-core';

@Component({
    selector: 'app-agent-trendgpt-modal',
    templateUrl: './agent-trendgpt-modal.component.html',
    styleUrl: './agent-trendgpt-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentTrendgptModalComponent extends AbstractComponent {
  public listChannel: Array<Channel> = [];


  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<AgentTrendgptModalComponent, Partial<Agent>>,
    private channelService: ChannelService
  ) {
    super(injector);
    this.setupForm();
  }

  ngOnInit(): void {
    this.getListChannel();
  }

  setupForm(): void {
    this.formGroup = this.formBuilder.group({
      channels: [[], [Validators.required]],
      name: [[], [Validators.required, Validators.maxLength(50)]],
      behavior: ['', [Validators.required, Validators.maxLength(3000)]],
      communicationType: [AgentCmmunicationTypeEnum.NORMAL, [Validators.required]],
      type: [AgentTypeEnum.SUPPORT, [Validators.required]],
      jobName: [],
      jobDescription: [],
    });
  }

  onChannelsSelection(selectEl: HTMLSelectElement) {
    const selected = Array.from(selectEl.selectedOptions).map(o => o.value);
    this.formGroup.get('channels')?.setValue(selected);
  }


  save(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const rawValue: Partial<Agent> = this.formGroup.getRawValue();
    const channels = this.formGroup.get('channels')?.value.map((idChannel: string) => {
      const channel = this.listChannel.find(c => c._id === idChannel);
      return { _id: channel._id, name: channel.name, type: channel.type };
    });

    const agentToSend = {
      ...rawValue,
      channels
    };

    this.dialogRef.close(agentToSend);
  }

  close(): void {
    this.dialogRef.close();
  }

  private normalize(value?: string | null): string | undefined {
    return value?.trim() || undefined;
  }


  private getListChannel(): void {
    this.channelService.getList().subscribe({
      next: (list: Array<Channel>) => {
        this.listChannel = list;
      },
    });
  }
}
